export const userBadgesColumnId = "userBadges";

export const onwerBadgeIcon = "crown";
